// extracted by mini-css-extract-plugin
export var article = "article-module--article--HQ1Aa";
export var languageBar = "article-module--languageBar--lVWWA";